import { render, staticRenderFns } from "./IndexBannerItem.vue?vue&type=template&id=6b0f0f52&scoped=true&"
import script from "./IndexBannerItem.vue?vue&type=script&lang=js&"
export * from "./IndexBannerItem.vue?vue&type=script&lang=js&"
import style0 from "styles/views/index/indexbanneritem.css?vue&type=style&index=0&id=6b0f0f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f0f52",
  null
  
)

export default component.exports